var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgImportExistingOrganization = function SvgImportExistingOrganization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.58 11.48H9.02v6.56h6.56v-6.56zM31.16 11.48H24.6v6.56h6.56v-6.56zM15.58 26.24H9.02v6.56h6.56v-6.56zM31.16 26.24H24.6v6.56h6.56v-6.56zM15.58 41H9.02v6.56h6.56V41zM31.16 41H24.6v6.56h6.56V41zM15.58 55.76H9.02v6.56h6.56v-6.56zM31.16 55.76H24.6v6.56h6.56v-6.56z",
    fill: "#33BB40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 30.34V0H0v82h82V30.34H41zm-3.28 48.38h-12.3V68.06h-9.84v10.66H3.28V3.28h34.44v75.44zM48.38 41h7.052v6.56H48.38V41zm0 14.76h7.052v6.56H48.38v-6.56zm16.4 25.42h-9.84V68.06h9.84v13.12zm7.462-18.86H65.19v-6.56h7.052v6.56zm0-14.76H65.19V41h7.052v6.56z",
    fill: "#33BB40"
  })));
};

export default SvgImportExistingOrganization;